var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card__buttons"},[_c('button',{staticClass:"button button_social",attrs:{"disabled":this.isLike},on:{"click":function($event){$event.preventDefault();return _vm.likeStory.apply(null, arguments)}}},[_c('i',{staticClass:"icon icon_like"}),_vm._v(" "),_c('span',[_vm._v("Like")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }